
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector",
      function () {
        return require("private-next-pages/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector"])
      });
    }
  